import React, { ButtonHTMLAttributes, ReactNode } from "react";

export interface ToggleBtnProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "style"> {
  size?: "md" | "sm";
  on?: boolean;
  children?: ReactNode;
}

const getToggleTailwind = (size: string, on: boolean) => {
  const baseStyles = "rounded-[40px]";

  if (size === "md") {
    if (on) {
      return `${baseStyles} bg-[#212121] text-white font-bold max-h-[36px] px-[20px] py-[8px] text-[14px] leading-[20px] tracking-[-0.28px]`;
    }
    return `${baseStyles} text-[#888888] font-medium max-h-[36px] px-[20px] py-[8px] text-[14px] leading-[20px] tracking-[-0.28px]`;
  }

  // size === "sm"
  if (on) {
    return `${baseStyles} bg-[#212121] text-white font-bold h-[32px] max-h-[32px] px-[16px] py-0 text-[14px] leading-[20px] tracking-[-0.28px] md:text-[16px] md:leading-[24px] md:tracking-[-0.32px]`;
  }
  return `${baseStyles} text-[#888888] font-medium h-[32px] max-h-[32px] px-[16px] py-0 text-[14px] leading-[20px] tracking-[-0.28px] md:text-[16px] md:leading-[24px] md:tracking-[-0.32px]`;
};

const Toggle: React.FC<ToggleBtnProps> = ({
  size = "md",
  on = true,
  children = "Label",
  ...props
}) => {
  const base = `
    box-border
    content-stretch
    flex gap-[8px] items-center justify-center
    transition-all duration-200 whitespace-nowrap`;
  const tw = getToggleTailwind(size, on);

  return (
    <button
      className={`${base} ${tw}`}
      type="button"
      aria-pressed={on}
      {...props}
    >
      {children}
    </button>
  );
};

export default Toggle;
